import React, { useEffect, useState } from "react";
import { FaRegPlusSquare } from "react-icons/fa";
import { FaRegSquareMinus } from "react-icons/fa6";
import { MdSubdirectoryArrowRight } from "react-icons/md";
const keyToSum = ["PT_WASTAGE_NUM"];
const MonthWisePath = ({ data, machineData }) => {
  const [machineRef, setMachineRef] = useState(null);
  const [sumData, setSumData] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [tableState, setTableState] = useState({});
  useEffect(() => {
    if (machineData) {
      Object.entries(machineData).forEach(([depart, value]) => {
        if (value.DEPARTMENT === "ENGINEERING") {
          setMachineRef(value?.children?.flatMap((obj) => obj?.children || []));
        }
      });
    }
  }, [machineData]);

  // console.log(machineRef);
  const tableOpenClose = (month, type) => {
    if (month) {
      const updated = {
        ...tableState,
        [month]: tableState[month] === undefined ? true : !tableState[month],
      };
      setTableState(updated);
    }
    if ((month, type)) {
      const updated = {
        ...tableState,
        [`${month}-${type}`]:
          tableState[`${month}-${type}`] === undefined
            ? true
            : !tableState[`${month}-${type}`],
      };
      setTableState(updated);
    }
  };
  // console.log(tableState);

  //   console.log(data);
  function sumByMonth(arr) {
    const result = arr.reduce((result, obj) => {
      const monthKey = new Date(obj.PT_DATE).toISOString().slice(0, 7); // e.g. "2025-07"
      const type = obj.PT_TYPE;

      // ensure month bucket exists
      if (!result[monthKey]) {
        result[monthKey] = {};
      }

      // initialize type counter
      if (!result[monthKey][type]) {
        result[monthKey][type] = 0;
      }

      // add value
      result[monthKey][type] += Number(obj.PT_WASTAGE_NUM) || 0;

      return result;
    }, {});

    // compute TOTAL across all months
    const total = {};
    Object.values(result).forEach((monthObj) => {
      Object.entries(monthObj).forEach(([type, sum]) => {
        if (!total[type]) total[type] = 0;
        total[type] += sum;
      });
    });

    // append TOTAL
    result["TOTAL"] = total;

    return result;
  }

  useEffect(() => {
    if (data && data.length > 0) {
      const sd = sumByMonth(data, keyToSum);
      setSumData(sd);
    }
  }, [data]);
  // console.log(sumData);
  // const tableObj = {};
  // useEffect(() => {
  //   if (sumData) {
  //     const monthSums = {};

  //     Object.entries(sumData).forEach(([key, value]) => {
  //       let a = 0;
  //       Object.entries(value).forEach(([type, totalValue]) => {
  //         a += totalValue;
  //       });
  //       monthSums[key] = a; // save the monthly sum
  //     });

  //     setMonthTotal(monthSums);
  //   }
  // }, [sumData]);

  function processWastageData(data, machineRef) {
    const getMonth = (d) => new Date(d).toISOString().slice(0, 7);

    // Build mapping of ASSET_DISCRIPTION → ASSET
    const assetMap = {};
    machineRef?.forEach((m) => {
      (m?.data || []).forEach((d) => {
        assetMap[d.ASSET_DISCRIPTION] = m.ASSET;
      });
    });

    const monthWise = {};
    const monthAssetWise = {};
    const nested = {};

    data.forEach((row) => {
      if (!row.PT_DATE || !row.PT_TYPE || !row.PT_WASTAGE_NUM) return;

      const month = getMonth(row.PT_DATE);
      const wastage = row.PT_WASTAGE_NUM;

      // 🔹 Split types by comma, remove whitespace
      const types = row.PT_TYPE.split(",")
        .map((t) => t.trim())
        .filter(Boolean);

      // Divide wastage equally among types (or change to full if required)
      const perTypeWastage = wastage / types.length;

      // 1️⃣ month-wise sum
      monthWise[month] = (monthWise[month] || 0) + wastage;

      types.forEach((type) => {
        const asset = assetMap[type] || "UNKNOWN";

        // 2️⃣ month + asset sum
        if (!monthAssetWise[month]) monthAssetWise[month] = {};
        monthAssetWise[month][asset] =
          (monthAssetWise[month][asset] || 0) + perTypeWastage;

        // 3️⃣ nested month → asset → sum
        if (!nested[month]) nested[month] = {};
        if (!nested[month][asset])
          nested[month][asset] = { total: 0, types: {} };

        nested[month][asset].total += perTypeWastage;
        nested[month][asset].types[type] =
          (nested[month][asset].types[type] || 0) + perTypeWastage;
      });
    });

    return { monthWise, monthAssetWise, nested };
  }
  useEffect(() => {
    if (data && data.length > 0 && machineData && machineData.length > 0) {
      const sum = processWastageData(data, machineRef);
      setTableData(sum);
    }
  }, [data, machineData]);
  return (
    <div className="m-1">
      <div className="row bg-dark papaDiv">
        <h5 className="text-white "> month wise summary</h5>
      </div>
      <div className="container papaDiv">
        <div className="responsive ">
          <table className="table table-hover table-striped">
            <thead>
              <tr className="table-dark text-white">
                <th>Sno</th>
                <th>Month</th>
                {/* <th>Machine Type</th> */}
                <th>Total path wastage</th>
              </tr>
            </thead>
            <tbody>
              {tableData &&
                Object.entries(tableData.monthWise).map(([key, sum], i) => {
                  return (
                    <React.Fragment>
                      <tr
                        key={i}
                        className=" table-dark"
                        style={{ cursor: "pointer" }}
                        onClick={() => tableOpenClose(key)}
                      >
                        <td>
                          {tableState[key] === true ? (
                            <FaRegSquareMinus />
                          ) : (
                            <FaRegPlusSquare />
                          )}{" "}
                          - {i + 1}
                        </td>
                        <td>{key}</td>
                        <td>{sum.toFixed(0)}</td>
                      </tr>

                      {tableState[key] === true &&
                        Object.entries(tableData.nested[key]).map(
                          ([assetName, assetValue], ind) => {
                            return (
                              <React.Fragment key={ind}>
                                {ind === 0 && (
                                  <tr className="table-secondary">
                                    <th>
                                      {" "}
                                      <MdSubdirectoryArrowRight /> Sno
                                    </th>
                                    <th>Head</th>
                                    <th>Path wastage</th>
                                  </tr>
                                )}
                                <tr
                                  onClick={() => tableOpenClose(key, assetName)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <td className="table-primary">
                                    {" "}
                                    {tableState[`${key}-${assetName}`] ===
                                    true ? (
                                      <FaRegSquareMinus />
                                    ) : (
                                      <FaRegPlusSquare />
                                    )}
                                    {/* <MdSubdirectoryArrowRight /> */}
                                    {ind + 1}
                                  </td>
                                  <td className="table-primary">{assetName}</td>
                                  <td className="table-primary">
                                    {assetValue.total.toFixed(0)}
                                  </td>
                                </tr>

                                {tableState[`${key}-${assetName}`] === true &&
                                  Object.entries(assetValue.types).map(
                                    ([assetDis, aValue], i) => {
                                      return (
                                        <React.Fragment key={i}>
                                          {/* {i === 0 && (
                                          <tr className="table-secondary">
                                          <td>
                                          {" "}
                                          <MdSubdirectoryArrowRight />
                                          Sno
                                          </td>
                                          <td>machine type</td>
                                          <td>Path wastage</td>
                                          </tr>
                                          )} */}
                                          {/* {console.log(
                                          assetDis,
                                          aValue,
                                          key
                                          // aValue[key][assetDis]
                                          )} */}
                                          {
                                            <tr>
                                              <td className="table-success">
                                                {"    "}
                                                <MdSubdirectoryArrowRight />
                                                {i + 1}
                                              </td>
                                              <td className="table-success">
                                                {assetDis}
                                              </td>
                                              <td className="table-success">
                                                {aValue.toFixed(0)}
                                              </td>
                                            </tr>
                                          }
                                        </React.Fragment>
                                      );
                                    },
                                  )}
                              </React.Fragment>
                            );
                          },
                        )}
                    </React.Fragment>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default MonthWisePath;
